<template>
  <div class="goodsDetailsImg">
    <div class="ImgDiv bd">
      <video v-if="mainInfo!=null&&mainInfo.fileType==3" class="videoClass" :poster="mainInfo.fileUrl" muted autoplay loop controls="controls" :src="mainInfo.videoUrl"></video>
      <img v-else :src="mainInfo!=null?mainInfo.fileUrl:goodsImg" class="videoClass" alt="">
    </div>
    <div class="ImgListDiv" v-if="mainInfo!=null">
      <div class="arrowClass" @click="imgLeft">
        <i class="el-icon-arrow-left arrowIcon" ></i>
      </div>
      <div class="ImgList">
         <img
            v-for="(item, index) in imgInfo"
            :key="index"
            :src="item.fileUrl"
            :style="imgStyle"
            @click="changeImg(item, index)" 
            class="goods_items_img"
            :class="index == imgActiveIndex ? 'img_activeBorder' : ''"
          />
      </div>
      <div class="arrowClass" @click="imgRight">
        <i class="el-icon-arrow-right arrowIcon" ></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    imgInfo:{
      type: Array,
      default: []
    }
  },
  data(){
    return {
      mainInfo:null,
      imgActiveIndex:0,
      imgDistance:0,
      goodsImg:require('../../assets/goods.jpg')
    }
  },
  computed:{
    imgStyle(){
      return {
        transform: `translate3d(${this.imgDistance}px, 0, 0)` // 计算移动的距离(x,y,z)
      }
    }
  },
  watch:{
    imgInfo(val){
      if(val.length>0){
        this.mainInfo = val[0] // 默认第一条
      }
    }
  },
  mounted(){
    
  },
  methods:{
    changeImg(item, index){
      this.mainInfo = item
      this.imgActiveIndex = index
    },
    imgLeft(){ 
      if (this.imgActiveIndex > 0) {
        this.imgActiveIndex-- // 索引值-1
        this.imgInfo.forEach((item, index) => {
          if (this.imgActiveIndex === index) {
            this.mainInfo = item
          }
        })
        this.moveIndex('left')
      }
    },
    imgRight(){
      if (this.imgActiveIndex < this.imgInfo.length - 1) {
        this.imgActiveIndex++
        this.imgInfo.forEach((item, index) => {
          if (this.imgActiveIndex == index) {
            this.mainInfo = item
          }
        })
        if (this.imgActiveIndex >= 5) {
          this.moveIndex('right')
        }
      }
    },
    moveIndex (direction){
      let newIndex = 0
      let that = this
      const temp = window.setInterval(() => {        
        if (direction == 'right') {
          if(Math.abs(that.imgDistance) == (this.imgInfo.length-5)*72){
            // 到达最后一个，不进行向右位移
             window.clearInterval(temp)
             return
          }
          if (newIndex < 72) { // 计数器位移72px后停止。72为图片大小的尺寸
            that.imgDistance -= 1
            newIndex++
            return
          } else {
            window.clearInterval(temp)
          }
        } else {
          if(that.imgDistance===0){
            // 到达第一个，不进行向左位移
            window.clearInterval(temp)
            return
          }
          if (newIndex < 72) { // 计数器位移72px后停止。72为图片大小的尺寸
            that.imgDistance += 1
            newIndex++
            return
          } else {
            window.clearInterval(temp)
          }
        }
      }, 1)
    }
  }
}
</script>

<style lang="less">
.goodsDetailsImg{
  .ImgDiv{
    width: 398px;
    height: 398px;
    .videoClass{
      width: 398px;
      height: 398px;
    }
  }
  .ImgListDiv{
    width: 400px;
    height: 72px;
    margin-top: 10px;
    display: flex;
    .ImgList{
      width: 360px;
      height: 72px;
      display: flex;
      align-items: center;
      overflow: hidden;
      .goods_items_img {
        width: 72px;
        height: 72px;
        // margin-right: 6px;
        border-radius: 4px;
        padding: 2px;
        box-sizing: border-box;
      }
    }
    .arrowClass{
      width: 20px;
      height: 72px;
      line-height: 72px;
      text-align: center;
      background: #ff4201;
      border-radius: 5px;
      .arrowIcon{
        color: #fff;
      }
    }
  }
  .img_activeBorder {
    border: 1px solid #ff4201;
  }
}
</style>